'use client';

import { SearchBar } from './search-bar';

export const SearchBarContainer = ({
  isMobile,
  isFeatureFlag,
  isHeadlessSearchEnabled = false,
  size,
  children,
  isHeadlessPDPEnabled,
  model,
  serialNumber
}: {
  isMobile?: boolean;
  isFeatureFlag: boolean;
  size?: 'lg' | 'md' | 'sm';
  children?: React.ReactNode;
  isHeadlessSearchEnabled: boolean;
  isHeadlessPDPEnabled: boolean;
  model?: string;
  serialNumber?: string;
}) => {
  return (
    <SearchBar
      isMobile={isMobile}
      isFeatureFlag={isFeatureFlag}
      size={size}
      isHeadlessSearchEnabled={isHeadlessSearchEnabled}
      isHeadlessPDPEnabled={isHeadlessPDPEnabled}
      model={model}
      serialNumber={serialNumber}
    >
      {children}
    </SearchBar>
  );
};
